import React from 'react';
import { Link } from 'react-router-dom';

const EmptyState = ({ activeTab, isUser }) => {
  const getTitle = () => {
    switch (activeTab) {
      case 'owner':
        return 'No car listings found';
      case 'driver':
        return 'No driver listings found';
      case 'my_posts':
        return 'No posts yet';
      default:
        return 'No posts found';
    }
  };

  const getMessage = () => {
    switch (activeTab) {
      case 'owner':
        return 'No car listings match your filters. Try adjusting your search or check back soon.';
      case 'driver':
        return 'No driver listings match your filters. Try adjusting your search or check back soon.';
      case 'my_posts':
        return "You haven't created any listings yet. Create a car or driver listing to get started.";
      default:
        return 'No posts match your filters. Try adjusting your search or check back soon.';
    }
  };

  return (
    <div className="empty-state">
      <div className="empty-icon">🚕</div>
      <h2>{getTitle()}</h2>
      <p>{getMessage()}</p>
      {isUser && activeTab === 'my_posts' && (
        <div className="empty-state-actions">
          <Link to="/car-listing" className="post-btn">
            Car Listing
          </Link>
          <Link to="/driver-listing" className="post-btn secondary">
            Driver Listing
          </Link>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
